import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Typography,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AcxButton from "components/UI/AcxButton";

import { observer } from "mobx-react";
import { default as IntegrationConfiguration } from "models/OrganizationModels/OrganizationIntegrationConfiguration";

import React from "react";
import { useStore } from "utils/useStore";
import IntegrationSettingItem from "./IntegrationSettingItem";
import {
    IntegrationStore,
    LOAD_INTEGRATION,
    SET_INTEGRATION,
} from "./IntegrationStore";

type Props = {
    orgId?: string;
};

const IntegrationSettings: React.FC<Props> = observer(({ orgId }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const integrationStore = useStore(IntegrationStore);

    const toggleAccordion = () => {
        setIsOpen((prev) => !prev);
    };

    const isLoading =
        integrationStore.getTaskLoading(LOAD_INTEGRATION) ||
        integrationStore.getTaskLoading(SET_INTEGRATION);

    React.useEffect(() => {
        if (!orgId) return;
        integrationStore.setOrgId(orgId);
    }, [integrationStore, orgId]);

    return (
        <Accordion
            square
            expanded={isOpen}
            onChange={toggleAccordion}
            sx={{ marginTop: 2 }}
        >
            <AccordionSummary>
                <Typography
                    sx={{
                        flexBasis: "60%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {isOpen ? (
                        <KeyboardArrowDownIcon />
                    ) : (
                        <KeyboardArrowRightIcon />
                    )}{" "}
                    Telephony Settings
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid item xs={12}>
                    <Grid
                        item
                        container
                        xs={12}
                        sx={{
                            justifyContent: "space-between",
                            paddingInline: "16px",
                        }}
                    >
                        <AcxButton
                            onClick={integrationStore.addItem}
                            color="primary"
                            disabled={
                                integrationStore.integrationConfiguration
                                    .length >= 1
                            }
                            tooltip={
                                integrationStore.integrationConfiguration
                                    .length >= 1
                                    ? "Only 1 URL allowed"
                                    : ""
                            }
                        >
                            Add URL
                        </AcxButton>
                        <AcxButton
                            onClick={
                                integrationStore.saveTelephonyConfiguration
                            }
                            color="primary"
                            loading={isLoading}
                            disabled={integrationStore.hasError}
                        >
                            Save
                        </AcxButton>
                    </Grid>
                    {integrationStore.integrationConfiguration.map(
                        (item: IntegrationConfiguration, index: number) => (
                            <IntegrationSettingItem
                                item={item}
                                index={index}
                                key={index}
                            />
                        ),
                    )}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default IntegrationSettings;
